module.exports = __webpack_public_path__ + "img/logo_white.7905f44a.svg";